export const convertToFivePointValue = (rate: number) => rate * 5;

export const formatRate = (rate: number) => convertToFivePointValue(rate).toFixed(2).replace('.', ',');
